import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DevAuthRequest } from '../models/dev-auth-request.model';
import { DevAuthModuleState } from '../models/dev-auth.model';

@Injectable({
  providedIn: 'root',
})
export class DevAuthService {
  constructor(protected http: HttpClient) {}
  httpGetDevAuthRequest(authRequestObject: DevAuthRequest): Observable<DevAuthModuleState> {
    const params: unknown = JSON.parse(authRequestObject.requestBody.toString());
    return this.http
      .request(
        `${authRequestObject.requestType}`,
        `${authRequestObject.requestURL}`,
        authRequestObject.requestType === 'GET' || authRequestObject.requestType === 'DELETE'
          ? {}
          : { body: params },
      )
      .pipe(map((response) => response));
  }
}
